<template>
  <!-- <?xml version="1.0" encoding="iso-8859-1"?> -->
  <!-- Generator: Adobe Illustrator 24.1.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg
    version="1.1"
    baseProfile="basic"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 48 48"
    xml:space="preserve"
    class="powerbi-svg"
    role="img"
    aria-label="Power BI logo animated"
  >
    <linearGradient
      id="SVGID_1_"
      gradientUnits="userSpaceOnUse"
      x1="32"
      y1="3.9472"
      x2="32"
      y2="44.7512"
    >
      <stop offset="0.0056" style="stop-color: #ebb112" />
      <stop offset="1" style="stop-color: #bb5c17" />
    </linearGradient>
    <path
      class="bar bar-1"
      style="fill: url(#SVGID_1_)"
      d="M27,44h10c1.105,0,2-0.895,2-2V6c0-1.105-0.895-2-2-2H27c-1.105,0-2,0.895-2,2v36
	C25,43.105,25.895,44,27,44z"
    />
    <linearGradient
      id="SVGID_2_"
      gradientUnits="userSpaceOnUse"
      x1="22.0886"
      y1="13.1404"
      x2="26.0093"
      y2="45.6723"
    >
      <stop offset="0" style="stop-color: #fed35d" />
      <stop offset="0.2808" style="stop-color: #f6c648" />
      <stop offset="0.8568" style="stop-color: #e3a513" />
      <stop offset="0.9888" style="stop-color: #de9d06" />
    </linearGradient>
    <path
      class="bar bar-2"
      style="fill: url(#SVGID_2_)"
      d="M19,44h10c1.105,0,2-0.895,2-2V16c0-1.105-0.895-2-2-2H19c-1.105,0-2,0.895-2,2v26
	C17,43.105,17.895,44,19,44z"
    />
    <linearGradient
      id="SVGID_3_"
      gradientUnits="userSpaceOnUse"
      x1="9.8026"
      y1="22.7811"
      x2="21.3352"
      y2="43.6582"
    >
      <stop offset="0" style="stop-color: #ffd869" />
      <stop offset="0.9832" style="stop-color: #ffdf26" />
    </linearGradient>
    <path
      class="bar bar-3"
      style="fill: url(#SVGID_3_)"
      d="M11,44h10c1.105,0,2-0.895,2-2V26c0-1.105-0.895-2-2-2H11c-1.105,0-2,0.895-2,2v16
	C9,43.105,9.895,44,11,44z"
    />
  </svg>
</template>

<script lang="ts" setup>
</script>

<style scoped>
/* Base animation settings for the bars */
.powerbi-svg .bar {
  animation-play-state: running; /* Start in running state */
  transform-box: fill-box; /* Ensure transform respects the element's own box */
  transform-origin: center bottom; /* Grow from the bottom for a nicer bar effect */
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1); /* smoother ease-out hover */
  will-change: transform; /* hint for smoother GPU-accelerated transforms */
  animation: powerbi-wave 4s ease-in-out infinite; /* 4s cycle for the wave */
  animation-fill-mode: both; /* keep first/last keyframe state when needed */
}

/* Progressive delays to create the wave effect (respecting DOM stacking order) */
/* Spread each bar's pulse evenly across the 4s cycle */
.powerbi-svg .bar-1 { animation-delay: 0s; }
.powerbi-svg .bar-2 { animation-delay: 1.333s; }
.powerbi-svg .bar-3 { animation-delay: 1.666s; }

/* Pulse wave: brief scale up then back to normal, rest of the cycle idle */

/* On hover over each bar, visually override transform without stopping the timeline */
.powerbi-svg .bar:hover {
  transform: scale(1.1) !important;
}

/* Respect user preferences */
/* @media (prefers-reduced-motion: reduce) {
  .powerbi-svg .bar {
    animation: none;
    transition: none;
  }
} */
</style>

<style>
/* Define keyframes globally to avoid scoped hashing issues that can stop animations */
@keyframes powerbi-wave {
  0% { transform: scale(1); }
  12% { transform: scale(1.1); }
  24% { transform: scale(1); }
  100% { transform: scale(1); }
}
</style>
